export const URLS = {
    ACCOUNT: '/earlypay/account',
    BORROW: '/earlypay/borrow',
    CARD_DETAILS: '/earlypay/card-details',
    CARD_DETAILS_LINK_NEW_CARD: '/earlypay/card-details?linkNewCard=true',
    EMAIL_VERIFICATION: '/earlypay/email-verification',
    EXCLUSIVE_OFFER: '/earlypay',
    KYC_INFO: '/earlypay/kyc-info',
    MEMBERSHIP_CONFIRMATION: '/earlypay/membership-confirmation',
    MEMBERSHIP_CANCELLATION: '/earlypay/membership-cancellation',
    NON_ACCOUNT_OWNER_ERROR: '/earlypay/non-account-owner-error',
    OFFER_APPROVED: '/earlypay/offer-approved',
    OFFER_DETAILS: '/earlypay/offer-details',
    PHONE_VERIFICATION: '/earlypay/phone-verification',
    KYC_PREFILL: '/earlypay/kyc-prefill',
    UNSUPPORTED_AUTH_METHOD: '/earlypay/unsupported-auth-method',
    SUBSCRIPTION_CANCELLED: '/earlypay/subscription-cancelled',
    SUBSCRIPTION_MANAGEMENT: '/earlypay/subscription-management',
    STEP_CARD_INTRO: '/earlypay/step-card-intro',
    LINK_BANK_ACCOUNT: '/earlypay/link-bank-account',
    TIER_DETAILS: '/earlypay/tier-details',
    TIER_DETAILS_CANCELLED: '/earlypay/tier-details?cancelled=true',
}

export const OnboardingURLS: string[] = [
    URLS.EXCLUSIVE_OFFER,
    URLS.EMAIL_VERIFICATION,
    URLS.PHONE_VERIFICATION,
    URLS.KYC_PREFILL,
    URLS.KYC_INFO,
    URLS.MEMBERSHIP_CONFIRMATION,
    URLS.CARD_DETAILS,
]

export const LoggedOutURLS: string[] = [
    URLS.EXCLUSIVE_OFFER,
    URLS.PHONE_VERIFICATION,
]
